module.exports = __webpack_public_path__ + "static/media/AI-Inverted.301ed632.png";